export default __webpack_public_path__ + "static/media/IMG3725.caff0c28.jpg";